import {
	Component,
	Input,
	OnChanges
} from '@angular/core';

import { VBrickPlayerComponent } from 'vbrick-player-src/VbrickPlayer.Component';

import { VideogularComponent } from '../Videogular.Component';

import { VgVolumeComponent } from './VgVolume.Component';

import styles from './VgMuteButton.module.less';

const CHANGE_PER_PRESS = 0.05;

@Component({
	selector: 'vg-mute-button',
	host: {
		'[class]': 'styles.root'
	},
	template: `
	<button
		type="button"
		[attr.aria-label]="isMuted ? vbrickPlayer.translations.unmute : vbrickPlayer.translations.mute"
		[tooltip]="isMuted ? vbrickPlayer.translations.unmute : vbrickPlayer.translations.mute"
		[placement]="'top'"
		[ngClass]="[
			styles.button,
			isBelowMidLevel ? styles.volumeHalf : '',
			isAboveMidLevel ? styles.volumeFull : '',
			isMuted ? styles.mute : ''
		]"
		vbControlBarFocus
		(click)="onClickMute()"
		(keydown)="vgVolume.onVolumeAreaKeyDown($event)">
	</button>
	`
})
export class VgMuteButtonComponent implements OnChanges {
	@Input() public currentVolume: number;

	public readonly styles = styles;

	constructor(
		public vbrickPlayer: VBrickPlayerComponent,
		private vgApi: VideogularComponent,
		public vgVolume: VgVolumeComponent
	) {}

	public ngOnChanges(): void {
		this.onSetVolume(this.currentVolume);
	}

	private get currentVolumePercent(): number {
		return Math.round(this.currentVolume * 100);
	}

	public get isBelowMidLevel(): boolean {
		return !this.isMuted && this.currentVolumePercent < 50;
	}

	public get isAboveMidLevel(): boolean {
		return this.currentVolumePercent >= 50;
	}

	public get isMuted(): boolean {
		return this.vgApi.isMuted;
	}

	public onClickMute(): void {
		this.vgApi.toggleSound();
	}

	private onSetVolume(newVolume: number): void {
		// if it's not muted we save the default volume OR if was muted but the user changed the volume
		if (!this.isMuted || newVolume > 0) {
			this.vgApi.defaultVolume = newVolume;
		}
	}
}
